require("../services-content/services-content");
require("../categories-content/categories-content");

const adminRoot = document.querySelector("[data-admin-root]");

function initAdminServicesContent() {
  const store = window.NMServicesContent;
  const categories = window.NMCategoriesContent;
  if (!store || !categories || !adminRoot || window.NMAdminServicesContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');

  const servicesList = document.querySelector("[data-services-list-admin]");
  const servicesCount = document.querySelector("[data-services-count]");
  const serviceCreateBtn = document.querySelector("[data-services-create]");

  const serviceModal = document.querySelector("[data-services-plaque-modal]");
  const serviceForm = document.querySelector("[data-services-plaque-form]");
  const serviceFormTitle = document.querySelector("[data-services-plaque-form-title]");
  const serviceImageInput = document.querySelector("#services-plaque-image");
  const serviceImageData = document.querySelector("[data-services-plaque-image-data]");
  const serviceImagePreview = document.querySelector("[data-services-plaque-image-preview]");
  const serviceImageReset = document.querySelector("[data-services-plaque-image-reset]");
  const categorySelect = serviceForm?.elements?.categoryKey;

  let editingServiceId = null;

  function hideOtherEditors() {
    if (contentHome) contentHome.hidden = true;
    if (aboutEditor) aboutEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    const articlesEditor = document.querySelector('[data-content-editor="articles"]');
    const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
  }

  function clearServiceErrors() {
    serviceForm?.querySelectorAll("[data-services-plaque-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-services-plaque-error]");
      if (error) error.hidden = true;
    });
  }

  function showServiceError(name) {
    const field = serviceForm?.querySelector(`[data-services-plaque-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-services-plaque-error]");
    if (error) error.hidden = false;
  }

  function updatePreview(root, src) {
    if (!root) return;
    const node = root;
    const img = node.querySelector("img");
    if (!src) {
      node.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    node.hidden = false;
  }

  function fillCategoryOptions(selectedKey) {
    if (!categorySelect) return;
    const list = categories.getCategories();
    categorySelect.innerHTML = list.map((item) => (
      `<option value="${store.escapeHtml(item.key)}">${store.escapeHtml(item.title)}</option>`
    )).join("");
    const preferred = selectedKey || list[0]?.key || "";
    if (preferred && list.some((item) => item.key === preferred)) {
      categorySelect.value = preferred;
    } else if (list[0]) {
      categorySelect.value = list[0].key;
    }
  }

  function closeServiceModal() {
    if (serviceModal) serviceModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingServiceId = null;
    if (serviceForm) serviceForm.reset();
    if (serviceImageData) serviceImageData.value = "";
    if (serviceImageInput) serviceImageInput.value = "";
    clearServiceErrors();
    updatePreview(serviceImagePreview, "");
  }

  function openServiceModal(serviceId) {
    if (!serviceForm) return;
    const list = categories.getCategories();
    if (!list.length) {
      window.alert("Сначала добавьте хотя бы одну категорию в разделе «Категории»."); // eslint-disable-line no-alert
      return;
    }

    const service = serviceId
      ? store.getServices().find((item) => item.id === serviceId)
      : null;
    editingServiceId = service ? service.id : null;

    fillCategoryOptions(service?.categoryKey);
    serviceForm.elements.name.value = service?.name || "";
    serviceForm.elements.description.value = service?.description || "";
    serviceForm.elements.showOnHome.checked = Boolean(service?.showOnHome);
    if (serviceImageData) serviceImageData.value = service?.image || "";
    if (serviceImageInput) serviceImageInput.value = "";
    updatePreview(serviceImagePreview, service?.image || "");
    if (serviceFormTitle) {
      serviceFormTitle.textContent = service ? "Изменить услугу" : "Новая услуга";
    }
    clearServiceErrors();
    if (serviceModal) serviceModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function renderServicesAdmin() {
    const items = store.getServices();
    const map = categories.getCategoryMap();
    if (servicesCount) servicesCount.textContent = `Услуг: ${items.length}`;
    if (!servicesList) return;

    if (!items.length) {
      servicesList.innerHTML = `
        <div class="admin-panel__services-empty">
          <p class="admin-panel__services-empty-title">Пока нет услуг</p>
          <p class="admin-panel__hint p3">Добавьте первую услугу — картинка, название, описание и категория</p>
        </div>
      `;
      return;
    }

    servicesList.innerHTML = items.map((service) => {
      const categoryTitle = map[service.categoryKey]?.title || service.categoryKey || "Без категории";
      const description = service.description || "Описание не указано";
      return `
        <article class="admin-panel__service-card">
          <div class="admin-panel__service-card-media">
            <img src="${store.escapeHtml(service.image)}" alt="" width="96" height="96">
          </div>
          <div class="admin-panel__service-card-body">
            <div class="admin-panel__service-card-top">
              <h4 class="admin-panel__service-card-title">${store.escapeHtml(service.name)}</h4>
              <div class="admin-panel__service-card-tags">
                <span class="admin-panel__service-tag">${store.escapeHtml(categoryTitle)}</span>
                ${service.showOnHome ? '<span class="admin-panel__service-tag admin-panel__service-tag_home">На главной</span>' : ""}
              </div>
            </div>
            <p class="admin-panel__service-card-desc">${store.escapeHtml(description)}</p>
          </div>
          <div class="admin-panel__service-card-actions">
            <button class="admin-panel__action-btn" type="button" data-services-edit="${store.escapeHtml(service.id)}">Изменить</button>
            <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-services-delete="${store.escapeHtml(service.id)}">Удалить</button>
          </div>
        </article>
      `;
    }).join("");
  }

  function showServicesEditor() {
    hideOtherEditors();
    if (servicesEditor) servicesEditor.hidden = false;
    closeServiceModal();
    renderServicesAdmin();
  }

  function handleServiceSubmit(event) {
    event.preventDefault();
    if (!serviceForm) return;
    clearServiceErrors();

    const name = String(serviceForm.elements.name.value || "").trim();
    const description = String(serviceForm.elements.description.value || "").trim();
    const image = String(serviceImageData?.value || "").trim();
    const categoryKey = String(serviceForm.elements.categoryKey?.value || "").trim();

    if (!name || !image) {
      showServiceError("name");
      return;
    }
    if (!categoryKey) {
      showServiceError("categoryKey");
      return;
    }

    store.upsertService({
      id: editingServiceId || store.createId(),
      name,
      description,
      image,
      categoryKey,
      showOnHome: Boolean(serviceForm.elements.showOnHome.checked),
    });

    store.hydratePublicServices();
    closeServiceModal();
    renderServicesAdmin();
  }

  document.querySelectorAll('[data-content-open="services"]').forEach((button) => {
    button.addEventListener("click", showServicesEditor);
  });

  serviceCreateBtn?.addEventListener("click", () => openServiceModal(null));
  serviceForm?.addEventListener("submit", handleServiceSubmit);

  document.querySelectorAll("[data-services-plaque-modal-close]").forEach((el) => {
    el.addEventListener("click", closeServiceModal);
  });

  servicesList?.addEventListener("click", (event) => {
    const editBtn = event.target.closest("[data-services-edit]");
    const deleteBtn = event.target.closest("[data-services-delete]");
    if (editBtn) openServiceModal(editBtn.getAttribute("data-services-edit"));
    if (deleteBtn) {
      const id = deleteBtn.getAttribute("data-services-delete");
      const service = store.getServices().find((item) => item.id === id);
      // eslint-disable-next-line no-alert
      if (!service || !window.confirm(`Удалить услугу «${service.name}»?`)) return;
      store.deleteService(id);
      store.hydratePublicServices();
      if (editingServiceId === id) closeServiceModal();
      renderServicesAdmin();
    }
  });

  if (serviceImageInput) {
    serviceImageInput.addEventListener("change", () => {
      const file = serviceImageInput.files?.[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (serviceImageData) serviceImageData.value = result;
        updatePreview(serviceImagePreview, result);
      };
      reader.readAsDataURL(file);
    });
  }

  serviceImageReset?.addEventListener("click", () => {
    if (serviceImageData) serviceImageData.value = "";
    if (serviceImageInput) serviceImageInput.value = "";
    updatePreview(serviceImagePreview, "");
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (serviceModal && !serviceModal.hidden) closeServiceModal();
  });

  document.addEventListener("nm:categories-updated", () => {
    if (servicesEditor && !servicesEditor.hidden) renderServicesAdmin();
  });

  window.NMAdminServicesContent = {
    showServicesEditor,
    closePlaqueModal: closeServiceModal,
    closePointModal: () => {},
    renderCategoriesAdmin: renderServicesAdmin,
    renderServicesAdmin,
  };
}

if (adminRoot) {
  initAdminServicesContent();
  window.setTimeout(initAdminServicesContent, 0);
}
